import type * as lazyIndex from "./lazyIndex";
import { LazyBootModule, LazyAction } from "owa-bundling-light";
import { registerLazyOrchestrator } from "owa-bundling";
import { onPinTaskbarShortcutTrigger } from "owa-nova-actions";

const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule<typeof lazyIndex>(() => import(/* webpackChunkName: "NativeControls" */ "./lazyIndex"), { name: "NativeControls" });

registerLazyOrchestrator(onPinTaskbarShortcutTrigger, lazyModule, m => m.onPinTaskbarShortcutOrchestrator);

export const lazyIsPinningAvailable: LazyAction<typeof lazyIndex.isPinningAvailable, typeof lazyModule> = new LazyAction(lazyModule, m => m.isPinningAvailable);
